module.exports = __webpack_public_path__ + "static/media/24.fe663003.svg";